import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Upload } from './pages/Upload';
import { Layout } from './components/Layout';
import { SnackbarProvider } from './context/SnackbarContext';
import './App.css';
import { FilesTable } from './components/FilesTable';
import { FileSelectionProvider } from './context/FileSelectionContext';
import Login from './pages/Login';
import Signup from './pages/Signup';
import { AuthProvider } from "./context/AuthContext";
import { FileDetails } from './pages/FileDetails';
import { ComplianceReport } from './pages/ComplianceReport';
import { ProtectedRoute } from './components/ProtectedRoute';

/**
 * ADA Compliance System - Frontend
 * 
 * Google OAuth authentication is required to access the application.
 * Users must sign in before accessing any application routes.
 */
function App() {
  return (
    <SnackbarProvider>
      <AuthProvider>
        <FileSelectionProvider>
          <Router>
            <Routes>
              {/* Default route - redirect to login */}
              <Route path="/" element={<Navigate to="/login" replace />} />

              {/* Login route - no authentication required */}
              <Route path="/login" element={<Login />} />

              {/* Marketplace sign-up route - no authentication required */}
              <Route path="/signup" element={<Signup />} />

              {/* Protected application routes - authentication required */}
              <Route path="/upload" element={
                <ProtectedRoute>
                  <Layout>
                    <Upload />
                  </Layout>
                </ProtectedRoute>
              } />

              <Route path="/files/:taskId/compliance" element={
                <ProtectedRoute>
                  <Layout>
                    <ComplianceReport />
                  </Layout>
                </ProtectedRoute>
              } />

              <Route path="/files/:taskId" element={
                <ProtectedRoute>
                  <Layout>
                    <FileDetails />
                  </Layout>
                </ProtectedRoute>
              } />

              <Route path="/files" element={
                <ProtectedRoute>
                  <Layout>
                    <FilesTable />
                  </Layout>
                </ProtectedRoute>
              } />

              {/* Catch all - redirect to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Router>
        </FileSelectionProvider>
      </AuthProvider>
    </SnackbarProvider>
  );
}

export default App;
